import { Option } from '../../../general-types';
import { deleteOptionsByValues } from '../../../shared/utils/arrayUtils';
import {
  CHALLENGE_CUSTOMER_TYPE,
  ChallengeCustomerType,
} from '../../constants/challengeCustomerType';
import {
  SCORING_RULE,
  scoringRuleOptions,
  ScoringRuleType,
} from '../../constants/scoringRule';

const scoringRuleOptionsForCustomerType: Record<
  ChallengeCustomerType,
  Option<ScoringRuleType>[]
> = {
  [CHALLENGE_CUSTOMER_TYPE.OPEN_TO_EVERYONE]: deleteOptionsByValues(scoringRuleOptions, [
    SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING,
  ]),
  [CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS]: scoringRuleOptions,
};

export const getScoringRuleOptionsForCustomerType = (
  customerType: ChallengeCustomerType | '' | null,
) => {
  return customerType ? scoringRuleOptionsForCustomerType[customerType] : [];
};
